/**
 * Utility functions for managing plan setup completion state
 */

/**
 * Check if plan setup has been completed
 * @returns {boolean} True if setup is completed and recent (within 24 hours)
 */
export const isPlanSetupCompleted = () => {
  const isSetupCompleted = localStorage.getItem("plan_setup_completed");
  const setupTimestamp = localStorage.getItem("plan_setup_completed_timestamp");
  
  if (isSetupCompleted === "true" && setupTimestamp) {
    const completionTime = parseInt(setupTimestamp);
    const currentTime = Date.now();
    const twentyFourHours = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
    
    // Return true if setup was completed within the last 24 hours
    return (currentTime - completionTime) < twentyFourHours;
  }
  
  return false;
};

/**
 * Mark plan setup as completed
 */
export const markPlanSetupCompleted = () => {
  localStorage.setItem("plan_setup_completed", "true");
  localStorage.setItem("plan_setup_completed_timestamp", Date.now().toString());
};

/**
 * Clear plan setup completion flag (for testing or reset purposes)
 */
export const clearPlanSetupCompletion = () => {
  localStorage.removeItem("plan_setup_completed");
  localStorage.removeItem("plan_setup_completed_timestamp");
};

/**
 * Check if a new setup is being started and clear completion flag if needed
 */
export const checkAndClearSetupCompletion = () => {
  const planSetupFromScratch = localStorage.getItem("plan_setup_from_scratch");
  const planSetupPending = localStorage.getItem("plan_setup_pending");
  
  // If starting a new setup, clear the completion flag
  if (planSetupFromScratch === "true" || planSetupPending === "true") {
    clearPlanSetupCompletion();
  }
};

/**
 * Get the time when plan setup was completed
 * @returns {Date|null} Date object or null if not completed
 */
export const getPlanSetupCompletionTime = () => {
  const setupTimestamp = localStorage.getItem("plan_setup_completed_timestamp");
  return setupTimestamp ? new Date(parseInt(setupTimestamp)) : null;
};
